module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-800-9ec580d40e2a33f76a4cec2cf04802e7.webp";